import React, { lazy } from "react";
import { Sidebar as BankAccountSidebar } from "../containers/tools/bankAccount";
import { Sidebar as WalletSidebar } from "../containers/tools/wallet";
import { Sidebar as ToolsSidebar } from "../containers/tools/tools";
import { Sidebar as ContactSidebar } from "../containers/tools/contact";
import { Sidebar as ConstructionPhaseSidebar } from "../containers/tools/constructionPhase";
import { Sidebar as ConstructionComponentSidebar } from "../containers/tools/constructionComponent";

const Dashboard = lazy(() => import("../containers/dashboard"));
const PrePayment = lazy(() => import("../containers/prePayment"));
const CreateData = lazy(()=> import("../containers/createData"));
const Payment = lazy(() => import("../containers/payment"));
const AccountReviewReportType = lazy(() =>
  import("../containers/accountReview/reportType")
);
const AccountReview = lazy(() => import("../containers/accountReview"));
const Activity = lazy(() => import("../containers/activity"));
const AddEmployee = lazy(() =>
  import("../containers/activity/components/addEmployee")
);
const EmployeeActivity = lazy(() =>
  import("../containers/activity/components/employeeActivity")
);
const PreReceive = lazy(() => import("../containers/preReceive"));
// const AddReceive = lazy(() => import("../containers/addReceive"));

const OverallCost = lazy(() => import("../containers/overallCost"));
const OverallCostDetail = lazy(() =>
  import("../containers/overallCost/components/detailPage")
);

const ChequeReview = lazy(() => import("../containers/chequeReview"));

const BalanceSheet = lazy(() => import("../containers/balanceSheet"));
const BalanceSheetDetail1 = lazy(() =>
  import("../containers/balanceSheet/subPage")
);
const BalanceSheetDetail2 = lazy(() =>
  import("../containers/balanceSheet/detailPage")
);
const CostAndProfit = lazy(() => import("../containers/costAndProfit"));

const Receive = lazy(() => import("../containers/receive"));
const Transfer = lazy(() => import("../containers/transfer"));

const Wallet = lazy(() => import("../containers/tools/wallet"));
const WalletEdit = lazy(() => import("../containers/tools/wallet/edit"));
const BankAccount = lazy(() => import("../containers/tools/bankAccount"));
const BankAccountEdit = lazy(() =>
  import("../containers/tools/bankAccount/edit")
);
const Tools = lazy(() => import("../containers/tools/tools"));
const ToolsEdit = lazy(() => import("../containers/tools/tools/edit"));
const ToolsAccountingEdit = lazy(() =>
  import("../containers/tools/tools/accounting")
);
const Contact = lazy(() => import("../containers/tools/contact"));
const ContactEdit = lazy(() => import("../containers/tools/contact/edit"));
const ContactAccountingEdit = lazy(() =>
  import("../containers/tools/contact/accounting")
);
const ConstructionPhase = lazy(() =>
  import("../containers/tools/constructionPhase")
);
const ConstructionPhaseEdit = lazy(() =>
  import("../containers/tools/constructionPhase/edit")
);
const ConstructionPhaseAccountingEdit = lazy(() =>
  import("../containers/tools/constructionPhase/accounting")
);
const ConstructionComponent = lazy(() =>
  import("../containers/tools/constructionComponent")
);
const ConstructionComponentEdit = lazy(() =>
  import("../containers/tools/constructionComponent/edit")
);
const ConstructionComponentAccountingEdit = lazy(() =>
  import("../containers/tools/constructionComponent/accounting")
);
const ProjectSetting = lazy(() => import("../containers/projectSetting"));
const ProjectBasicInfo = lazy(() => import("../containers/projectBasicInfo"));
const PettyCash = lazy(() => import("../containers/pettyCash"));
const PettyCashReport = lazy(() => import("../containers/pettyCashReport"));
const ConnectToAccountingSoftware = lazy(() =>
  import("../containers/connectToAccountingSoftware")
);

const PaymentSummery = React.lazy(() =>
  import("../containers/summary/payment")
);
const ReceiveSummery = React.lazy(() =>
  import("../containers/summary/receive")
);
const TransferSummery = React.lazy(() =>
  import("../containers/summary/transfer")
);
const ActivitySummery = React.lazy(() =>
  import("../containers/summary/activity")
);
const PettyCashSummery = React.lazy(() =>
  import("../containers/summary/pettyCash")
);
const AccountLevel = React.lazy(() => import("../containers/accountLevel"));
const File = React.lazy(() => import("../containers/file"));
const Feedback = lazy(() => import("../containers/feedback"));
const UserAccountSetting = React.lazy(() =>
  import("../containers/userAccountSetting")
);
const EditUserAccountSetting = React.lazy(() =>
  import("../containers/userAccountSetting/edit")
);
const ChangePassword = React.lazy(() =>
  import("../containers/userAccountSetting/changePassword")
);
const SharedContacts = React.lazy(() => import("../containers/sharedContacts"));
const Backup = React.lazy(() => import("../containers/backup"));
const GetBackupFile = React.lazy(() =>
  import("../containers/backup/container/getBackupFile")
);
const Purchase = React.lazy(() => import("../containers/purchase"));
// const PurchaseNew = React.lazy(() => import("../containers/purchase_new"));
const CashFlow = lazy(() => import("../containers/cashFlow"));
const AllPaymentHistory = React.lazy(()=> import("../containers/userAccountSetting/components/paymentHistory/components/allPaymentHistory"));
const MapsaInvitation = React.lazy(()=> import("../containers/mapsaInvitation"));
const PaymentHistory = React.lazy(() =>
  import("../containers/summary/premiumPlan")
);
const ProjectsManagement = React.lazy(() => import ("../containers/projectsManagement"));

const routes = [
  {
    path: "/",
    component: Dashboard,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/accountreview",
    component: AccountReviewReportType,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/account-review",
    component: AccountReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/create-data",
    component: CreateData,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/pre-payment",
    component: PrePayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/add-payment",
    component: Payment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/edit-payment/:id",
    component: Payment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/pre-receive",
    component: PreReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/add-receive",
    component: Receive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/edit-receive/:id",
    component: Receive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/pettycash_report",
    component: PettyCashReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/pettycash",
    component: PettyCash,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/pettycash/:id",
    component: PettyCash,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/functions",
    component: Activity,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/functions/employee",
    component: AddEmployee,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/functions/detail",
    component: EmployeeActivity,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/add-transfer",
    component: Transfer,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/edit-transfer/:id",
    component: Transfer,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/overall-cost",
    component: OverallCost,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/overall-cost/detail",
    component: OverallCostDetail,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/cheque-review",
    component: ChequeReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/cost-profit",
    component: CostAndProfit,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/wallet",
    component: Wallet,
    options: { sidebar: WalletSidebar }, // TODO: think for better way to do it
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/wallet/:id/edit",
    component: WalletEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/bank-account",
    component: BankAccount,
    options: { sidebar: BankAccountSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/bank-account/:id/edit",
    component: BankAccountEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/tools",
    component: Tools,
    options: { sidebar: ToolsSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/tools/:id/edit",
    component: ToolsEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/tools/:id/accounting/edit",
    component: ToolsAccountingEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/contact",
    component: Contact,
    options: { sidebar: ContactSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/contact/:id/edit",
    component: ContactEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/contact/:id/accounting/edit",
    component: ContactAccountingEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-phase",
    component: ConstructionPhase,
    options: { sidebar: ConstructionPhaseSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-phase/:id/edit",
    component: ConstructionPhaseEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-phase/:id/accounting/edit",
    component: ConstructionPhaseAccountingEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-component",
    component: ConstructionComponent,
    options: { sidebar: ConstructionComponentSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-component/:id/edit",
    component: ConstructionComponentEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/construction-component/:id/accounting/edit",
    component: ConstructionComponentAccountingEdit,
    layout: "tools.fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/balance-sheet",
    component: BalanceSheet,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/balance-sheet/:id",
    component: BalanceSheetDetail1,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/balance-sheet/:parent_id/detail/:id?",
    component: BalanceSheetDetail2,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/project-setting",
    component: ProjectSetting,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: "/project-setting/project-basic-info",
    component: ProjectBasicInfo,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/project-setting/connect-to-accounting-software",
    component: ConnectToAccountingSoftware,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/summary-payment/:id",
    component: PaymentSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/summary-receive/:id",
    component: ReceiveSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/summary-transfer/:id",
    component: TransferSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/summary-activity/:id",
    component: ActivitySummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/summary-pettycash/:id",
    component: PettyCashSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: "/project-setting/account-level",
    component: AccountLevel,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/files",
    component: File,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: "/feedback",
    component: Feedback,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/user-account-setting",
    component: UserAccountSetting,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: "/user-account-setting/edit",
    component: EditUserAccountSetting,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/user-account-setting/change-password",
    component: ChangePassword,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/project-member-management",
    component: SharedContacts,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: "/backup",
    component: Backup,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: "/backup/get-backup-file",
    component: GetBackupFile,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/purchase",
    component: Purchase,
    options: {},
    layout: "fullpage",
    visibility: "all"
  },
  // {
  //   path: "/purchase_new",
  //   component: PurchaseNew,
  //   options: {},
  //   layout: "fullpage",
  //   visibility: "all"
  // },
  {
    path: "/cash-flow",
    component: CashFlow,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  // {
  //   path: "/user-account-setting/payments-history",
  //   component: AllPaymentHistory,
  //   options: {},
  //   layout: "fullpage",
  //   visibility: "trust"
  // },
  {
    path: "/invitation",
    component: MapsaInvitation,
    options: {},
    layout: "fullpage",
    visibility: "all"
  },
  {
    path: "/user-account-setting/payments-history/:id",
    component: PaymentHistory,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: "/projects-management",
    component: ProjectsManagement,
    layout: "fullpage",
    visibility: "trust"
  },

];
export default routes;
